import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
import { Link } from 'react-router-dom';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative py-32 flex items-center justify-center overflow-hidden" data-id="element-38" data-mp="m4ovq8zo13ay">
      {/* Background Image with Heavy Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/nm2vvmbFNr7jJiMfCXYQ18/Gemini_Generated_Image_1prdd51prdd51prd.png")'
    }} data-id="element-39" data-mp="h52hpxc0jj13" />
      <div className="absolute inset-0 z-10 bg-navy/80 backdrop-blur-sm" data-id="element-40" data-mp="14uofcgcqlq6z" />

      <div className="relative z-20 max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-41" data-mp="zwd1zvn8gxk0">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} data-id="element-42" data-mp="zuihujjsd9gz">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading text-warmWhite mb-12 leading-tight" data-id="element-43" data-mp="2r1xfus1n87fv">
            {t('finalCta.headline1')}{' '}
            <span className="text-saffron italic" data-id="element-44" data-mp="2v2r5pqynbwbe">
              {t('finalCta.headline2')}
            </span>
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-20" data-id="element-45" data-mp="300iuwd7wp4bw">
            <a href="https://form.typeform.com/to/BGQF1C1p" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-saffron text-navy rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-warmWhite transition-colors duration-300 shadow-lg hover:shadow-xl text-center" data-id="element-46" data-mp="34u3u28l8k4co">
              {t('finalCta.cta1')}
            </a>
            <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-warmWhite/50 text-warmWhite rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-warmWhite/10 hover:border-warmWhite transition-colors duration-300 text-center" data-id="element-47" data-mp="1ep8sbxa2lkay">
              {t('finalCta.cta2')}
            </a>
          </div>

          <div className="mt-12 pt-12 border-t border-warmWhite/10 text-warmWhite/60 text-sm" data-id="element-48" data-mp="1xfi3vxrqyofb">
            <p data-id="element-49" data-mp="2beq50w7h06m5">
              For large donations or corporate sponsorships, please{' '}
              <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="text-saffron hover:text-warmWhite transition-colors" data-id="element-50" data-mp="27efo4oi53vsi">
                contact us directly
              </a>
              .
            </p>
          </div>
        </motion.div>

        {/* Footer */}
        <div className="border-t border-warmWhite/20 pt-8 flex flex-col md:flex-row justify-between items-center text-warmWhite/50 text-sm" data-id="element-51" data-mp="6wi6kdtoovar">
          <p data-id="element-52" data-mp="3p9gbz098wgcb">{t('finalCta.copyright')}</p>
          <div className="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2 mt-4 md:mt-0" data-id="element-53" data-mp="3ua45bsky599p">
            <Link to="/pitch-deck" className="hover:text-warmWhite transition-colors" data-id="element-54" data-mp="3fd3k87x9gck7">
              {t('finalCta.pitchDeck')}
            </Link>
            <a href="mailto:CancunGurdwara@gmail.com" className="hover:text-warmWhite transition-colors" data-id="element-55" data-mp="36d84dpsrftdu">
              CancunGurdwara@gmail.com
            </a>
            <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="hover:text-warmWhite transition-colors" data-id="element-56" data-mp="14ksd964f0787">
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>;
}